import { PerformanceState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import { INewReportList, TaskRecordQuery } from "@/interfaces";
export const getters = {
  performances: (state: PerformanceState) => {
    return state.performances;
  },
  all_performances: (state: PerformanceState) => {
    return state.all_performances;
  },
  upload_top_performance_load: (state: PerformanceState) => {
    return state.upload_top_performance_load;
  },
  top_templates: (state: PerformanceState) => {
    return state.top_templates;
  },
  top_baselines: (state: PerformanceState) => {
    return state.top_baselines;
  },
  top_templates_data: (state: PerformanceState) => {
    return state.top_templates_data;
  },
  top_baselines_data: (state: PerformanceState) => {
    return state.top_baselines_data;
  },
  performanceTableFields: (state: PerformanceState) => {
    return state.performance_table_fields;
  },
  performance_select_options: (state: PerformanceState) => {
    return state.performance_select_options;
  },
  performance_custom_version: (state: PerformanceState) => {
    return state.performance_custom_version;
  },
  deep_performance_select_options: (state: PerformanceState) => {
    return state.deep_performance_select_options;
  },
  deep_performance_select_options_old: (state: PerformanceState) => {
    return state.deep_performance_select_options_old;
  },
  deep_performance_select_options_last: (state: PerformanceState) => {
    return state.deep_performance_select_options_last;
  },
  deep_scene: (state: PerformanceState) => {
    return state.deep_scene;
  },
  deep_scene_options: (state: PerformanceState) => {
    return state.deep_scene_options;
  },
  deep_scene_report: (state: PerformanceState) => {
    return state.deep_scene_port;
  },
  deep_scene_vedio: (state: PerformanceState) => {
    return state.deep_scene_vedio;
  },
  pkg_resource_date: (state: PerformanceState) => {
    return state.pkg_resource_date;
  },
  pkg_resource_device: (state: PerformanceState) => {
    return state.pkg_resource_device;
  },
  pkg_resource_scene: (state: PerformanceState) => {
    return state.pkg_resource_scene;
  },
  pkg_resource_list: (state: PerformanceState) => {
    return state.pkg_resource_list;
  },
  pkg_resource_report: (state: PerformanceState) => {
    return state.pkg_resource_report;
  },
  pkg_resource_list_old: (state: PerformanceState) => {
    return state.pkg_resource_list_old;
  },
  pkg_resource_list_thread_old: (state: PerformanceState) => {
    return state.pkg_resource_list_thread_old;
  },
  pkg_type_list: (state: PerformanceState) => {
    return state.pkg_type_list;
  },
  pkg_type_list_old: (state: PerformanceState) => {
    return state.pkg_type_list_old;
  },
  pkg_resource_sum: (state: PerformanceState) => {
    return state.pkg_resource_sum;
  },
  pkg_type_rate: (state: PerformanceState) => {
    return state.pkg_type_rate;
  },
  pkg_asset_stack: (state: PerformanceState) => {
    return state.pkg_asset_stack;
  },
  pkg_asset_type: (state: PerformanceState) => {
    return state.pkg_asset_type;
  },
  pkg_struct_stack: (state: PerformanceState) => {
    return state.pkg_struct_stack;
  },
  speedm_memory_list: (state: PerformanceState) => {
    return state.speedm_memory_list;
  },
  speedm_memory_config: (state: PerformanceState) => {
    return state.speedm_memory_config;
  },
  mem_summary_list: (state: PerformanceState) => {
    return state.mem_summary_list;
  },
  mem_summary_trend: (state: PerformanceState) => {
    return state.mem_summary_trend;
  },
  mem_summary_trend_ios: (state: PerformanceState) => {
    return state.mem_summary_trend_ios;
  },
  mem_date_versions: (state: PerformanceState) => {
    return state.mem_date_versions;
  },
  mem_summary_list_v1: (state: PerformanceState) => {
    return state.mem_summary_list_v1;
  },
  resource_dates: (state: PerformanceState) => {
    return state.resource_dates;
  },
  resource_car_list: (state: PerformanceState) => {
    return state.resource_car_list;
  },
  resource_load_list: (state: PerformanceState) => {
    return state.resource_load_list;
  },
  resource_skin_list: (state: PerformanceState) => {
    return state.resource_skin_list;
  },
  resource_overall: (state: PerformanceState) => {
    return state.resource_overall;
  },
  resource_average_data: (state: PerformanceState) => {
    return state.resource_average_data;
  },
  resource_average_chart: (state: PerformanceState) => {
    return state.resource_average_chart;
  },
  resource_history: (state: PerformanceState) => {
    return state.resource_history;
  },
  resource_average_chart_avg: (state: PerformanceState) => {
    return state.resource_average_chart_avg;
  },
  resource_scan_type_list: (state: PerformanceState) => {
    return state.resource_scan_type_list;
  },
  resource_car_data: (state: PerformanceState) => {
    return state.resource_car_data;
  },
  resource_records: (state: PerformanceState) => {
    return state.resource_records;
  },
  resource_versions: (state: PerformanceState) => {
    return state.resource_versions;
  },
  resource_devices: (state: PerformanceState) => {
    return state.resource_devices;
  },
  resource_scenes: (state: PerformanceState) => {
    return state.resource_scenes;
  },
  resource_id: (state: PerformanceState) => {
    return state.resource_id;
  },
  speedm_memory_scenes: (state: PerformanceState) => {
    return state.speedm_memory_scenes;
  },
  speedm_memory_records: (state: PerformanceState) => {
    return state.speedm_memory_records;
  },
  speedm_memory_filename_list: (state: PerformanceState) => {
    return state.speedm_memory_filename_list;
  },
  speedm_memory_source_list: (state: PerformanceState) => {
    return state.speedm_memory_source_list;
  },
  speedm_memory_source_file_list: (state: PerformanceState) => {
    return state.speedm_memory_source_file_list;
  },
  speedm_mod_summary: (state: PerformanceState) => {
    return state.speedm_mod_summary;
  },
  speedm_mod_summary_v1: (state: PerformanceState) => {
    return state.speedm_mod_summary_v1;
  },
  speedm_memory_res_summary: (state: PerformanceState) => {
    return state.speedm_memory_res_summary;
  },
  speedm_mod_list: (state: PerformanceState) => {
    return state.speedm_mod_list;
  },
  speedm_mod_res_list: (state: PerformanceState) => {
    return state.speedm_mod_res_list;
  },
  speedm_memory_res_trend: (state: PerformanceState) => {
    return state.speedm_memory_res_trend;
  },
  speedm_summary_list: (state: PerformanceState) => {
    return state.speedm_summary_list;
  },
  speedm_mod_trend: (state: PerformanceState) => {
    return state.speedm_mod_trend;
  },
  speedm_memory_trend: (state: PerformanceState) => {
    return state.speedm_memory_trend;
  },
  speedm_memory_summary: (state: PerformanceState) => {
    return state.speedm_memory_summary;
  },
  pkg_map_struct_stack: (state: PerformanceState) => {
    return state.pkg_map_struct_stack;
  },
  pkg_map_struct_stack_list: (state: PerformanceState) => {
    return state.pkg_map_struct_stack_list;
  },
  pkg_map_struct_stack_option: (state: PerformanceState) => {
    return state.pkg_map_struct_stack_option;
  },
  pkg_asset_stack_find: (state: PerformanceState) => {
    return state.pkg_asset_stack_find;
  },
  pkg_resource_trend: (state: PerformanceState) => {
    return state.pkg_resource_trend;
  },
  pkg_asset_trend: (state: PerformanceState) => {
    return state.pkg_asset_trend;
  },
  pkg_struct_trend: (state: PerformanceState) => {
    return state.pkg_struct_trend;
  },
  pkg_abnorma_trend: (state: PerformanceState) => {
    return state.pkg_abnorma_trend;
  },
  pkg_map_struct_trend: (state: PerformanceState) => {
    return state.pkg_map_struct_trend;
  },
  pkg_type_table: (state: PerformanceState) => {
    return state.pkg_type_table;
  },
  deep_cpu_labels: (state: PerformanceState) => {
    return state.deep_cpu_labels;
  },
  deep_cpu_usage_trend: (state: PerformanceState) => {
    return state.deep_cpu_usage_trend;
  },
  deep_cpu_labels_old: (state: PerformanceState) => {
    return state.deep_cpu_labels_old;
  },
  deep_cpu_perf_trend: (state: PerformanceState) => {
    return state.deep_cpu_perf_trend;
  },
  deep_cpu_custom_trend: (state: PerformanceState) => {
    return state.deep_cpu_custom_trend;
  },
  deep_cpu_threads: (state: PerformanceState) => {
    return state.deep_cpu_threads;
  },
  deep_fps_inside_trend: (state: PerformanceState) => {
    return state.deep_fps_inside_trend;
  },
  deep_cpu_trend: (state: PerformanceState) => {
    return state.deep_cpu_trend;
  },
  deep_flame_url: (state: PerformanceState) => {
    return state.deep_flame_url;
  },
  deep_cpu_so_trend: (state: PerformanceState) => {
    return state.deep_cpu_so_trend;
  },
  deep_cpu_thread_trend: (state: PerformanceState) => {
    return state.deep_cpu_thread_trend;
  },
  deep_cpu_module_trend: (state: PerformanceState) => {
    return state.deep_cpu_module_trend;
  },
  deep_cpu_versions: (state: PerformanceState) => {
    return state.deep_cpu_versions;
  },
  deep_cpu_config: (state: PerformanceState) => {
    return state.deep_cpu_config;
  },
  deep_cpu_func_trend: (state: PerformanceState) => {
    return state.deep_cpu_func_trend;
  },
  deep_cpu_config_so_list: (state: PerformanceState) => {
    return state.deep_cpu_config_so_list;
  },
  deep_cpu_versions_old: (state: PerformanceState) => {
    return state.deep_cpu_versions_old;
  },
  deep_cpu_function: (state: PerformanceState) => {
    return state.deep_cpu_function;
  },
  deep_cpu_function_overview: (state: PerformanceState) => {
    return state.deep_cpu_function_overview;
  },
  deep_cpu_thread_list: (state: PerformanceState) => {
    return state.deep_cpu_thread_list;
  },
  deep_cpu_custom_data: (state: PerformanceState) => {
    return state.deep_cpu_custom_data;
  },
  deep_cpu_usage_list: (state: PerformanceState) => {
    return state.deep_cpu_usage_list;
  },
  deep_cpu_usage_list_qq: (state: PerformanceState) => {
    return state.deep_cpu_usage_list_qq;
  },
  deep_cpu_usage_list_moudule_qq: (state: PerformanceState) => {
    return state.deep_cpu_usage_list_moudule_qq;
  },
  deep_cpu_report: (state: PerformanceState) => {
    return state.deep_cpu_report;
  },
  deep_func_list: (state: PerformanceState) => {
    return state.deep_func_list;
  },
  deep_cpu_by_frame: (state: PerformanceState) => {
    return state.deep_cpu_by_frame;
  },
  deep_cpu_stack: (state: PerformanceState) => {
    return state.deep_cpu_stack;
  },
  deep_cpu_stack_find: (state: PerformanceState) => {
    return state.deep_cpu_stack_find;
  },
  token_library_list: (state: PerformanceState) => {
    return state.token_library_list;
  },
  deep_frame_problem: (state: PerformanceState) => {
    return state.deep_frame_problem;
  },
  deep_avg_stack: (state: PerformanceState) => {
    return state.deep_avg_stack;
  },
  deep_cpu_stack_creat: (state: PerformanceState) => {
    return state.deep_cpu_stack_creat;
  },
  deep_cpu_stack_creat_old: (state: PerformanceState) => {
    return state.deep_cpu_stack_creat_old;
  },
  deep_scene_old: (state: PerformanceState) => {
    return state.deep_scene_old;
  },
  deep_cpu_function_cos: (state: PerformanceState) => {
    return state.deep_cpu_function_cos;
  },
  deep_cpu_trend_node: (state: PerformanceState) => {
    return state.deep_cpu_trend_node;
  },
  deep_cpu_function_model: (state: PerformanceState) => {
    return state.deep_cpu_function_model;
  },
  deep_cpu_detail: (state: PerformanceState) => {
    return state.deep_cpu_detail;
  },
  deep_cpu_thread_by_frame: (state: PerformanceState) => {
    return state.deep_cpu_thread_by_frame;
  },
  deep_caton_list: (state: PerformanceState) => {
    return state.deep_caton_list;
  },
  deep_cpu_put_check: (state: PerformanceState) => {
    return state.deep_cpu_put_check;
  },
  deep_scene_old_vedio: (state: PerformanceState) => {
    return state.deep_scene_old_vedio;
  },
  deep_find: (state: PerformanceState) => {
    return state.deep_find;
  },
  date_versions: (state: PerformanceState) => {
    return state.date_versions;
  },
  performance_page_list: (state: PerformanceState) => {
    return state.performance_page_list;
  },
  setPerformancePageListSummary: (state: PerformanceState) => {
    return state.setPerformancePageListSummary;
  },
  deep_performance_page_list: (state: PerformanceState) => {
    return state.deep_performance_page_list;
  },
  test_info: (state: PerformanceState) => {
    return state.test_info;
  },
  label_info: (state: PerformanceState) => {
    return state.label_info;
  },
  label_info_laebl: (state: PerformanceState) => {
    return state.label_info_laebl;
  },
  avg_data: (state: PerformanceState) => {
    return state.avg_data;
  },
  perf_info: (state: PerformanceState) => {
    return state.perf_info;
  },
  perf_second_data: (state: PerformanceState) => {
    return state.cperf_second_data;
  },
  reprot_list: (state: PerformanceState) => {
    return state.report_list;
  },
  new_reprot: (state: PerformanceState) => {
    return state.new_report;
  },
  new_smg_report: (state: PerformanceState) => {
    return state.new_smg_report;
  },
  nzm_memory_stack_all: (state: PerformanceState) => {
    return state.nzm_memory_stack_all;
  },
  skin_management: (state: PerformanceState) => {
    return state.skin_management;
  },
  sgame_skin_option: (state: PerformanceState) => {
    return state.sgame_skin_option;
  },
  sgame_skin_data: (state: PerformanceState) => {
    return state.sgame_skin_data;
  },
  sgame_skin_list: (state: PerformanceState) => {
    return state.sgame_skin_list;
  },
  skin_pkg: (state: PerformanceState) => {
    return state.skin_pkg;
  },
  skin_date: (state: PerformanceState) => {
    return state.skin_date;
  },
  new_report_list: (state: PerformanceState) => {
    return state.new_report_list;
  },
  skin_line_viewt: (state: PerformanceState) => {
    return state.skin_line_viewt;
  },
  test_case_list: (state: PerformanceState) => {
    return state.test_case_list;
  },
  test_case: (state: PerformanceState) => {
    return state.test_case;
  },
  case_control: (state: PerformanceState) => {
    return state.case_control;
  },
  simple_date_options: (state: PerformanceState) => {
    return state.simple_date_options;
  },
  deep_memory_options: (state: PerformanceState) => {
    return state.deep_memory_options;
  },
  deep_memory_llm_list: (state: PerformanceState) => {
    return state.deep_memory_llm_list;
  },
  deep_memory_trend: (state: PerformanceState) => {
    return state.deep_memory_trend;
  },
  deep_memory_date_options: (state: PerformanceState) => {
    return state.deep_memory_date_options;
  },
  deep_memory_recond_list: (state: PerformanceState) => {
    return state.deep_memory_recond_list;
  },
  deep_memory_circle_chart: (state: PerformanceState) => {
    return state.deep_memory_circle_chart;
  },
  deep_uobject: (state: PerformanceState) => {
    return state.deep_uobject;
  },
  deep_uobject_trend: (state: PerformanceState) => {
    return state.deep_uobject_trend;
  },
  memory_date: (state: PerformanceState) => {
    return state.memory_date;
  },
  memory_version: (state: PerformanceState) => {
    return state.memory_version;
  },
  memory_device: (state: PerformanceState) => {
    return state.memory_device;
  },
  memory_device_second: (state: PerformanceState) => {
    return state.memory_device_second;
  },
  memory_scene: (state: PerformanceState) => {
    return state.memory_scene;
  },
  memory_type: (state: PerformanceState) => {
    return state.memory_type;
  },
  memory_date_version: (state: PerformanceState) => {
    return state.memory_date_version;
  },
  memory_date_version_new: (state: PerformanceState) => {
    return state.memory_date_version_new;
  },
  memory_date_version_device: (state: PerformanceState) => {
    return state.memory_date_version_device;
  },
  memory_level: (state: PerformanceState) => {
    return state.memory_level;
  },
  memory_scene_second: (state: PerformanceState) => {
    return state.memory_scene_second;
  },
  memory_module_all: (state: PerformanceState) => {
    return state.memory_module_all;
  },
  memory_object_memory_report: (state: PerformanceState) => {
    return state.memory_object_memory_report;
  },
  memory_object_memory_trend: (state: PerformanceState) => {
    return state.memory_object_memory_trend;
  },
  memory_funtion_trend: (state: PerformanceState) => {
    return state.memory_funtion_trend;
  },
  memory_funtion_id: (state: PerformanceState) => {
    return state.memory_funtion_id;
  },
  memory_module_id: (state: PerformanceState) => {
    return state.memory_module_id;
  },
  memory_funtion_trend_draw: (state: PerformanceState) => {
    return state.memory_funtion_trend_draw;
  },
  memory_list: (state: PerformanceState) => {
    return state.memory_list;
  },
  memory_list_data: (state: PerformanceState) => {
    return state.memory_list_data;
  },
  memory_stack: (state: PerformanceState) => {
    return state.memory_stack;
  },
  memory_sub_stack_old: (state: PerformanceState) => {
    return state.memory_sub_stack_old;
  },
  memory_all_stack: (state: PerformanceState) => {
    return state.memory_all_stack;
  },
  memory_appoint_stack: (state: PerformanceState) => {
    return state.memory_appoint_stack;
  },
  memory_appoint_old_left_stack: (state: PerformanceState) => {
    return state.memory_appoint_old_left_stack;
  },
  memory_appoint_old_right_stack: (state: PerformanceState) => {
    return state.memory_appoint_old_right_stack;
  },
  memory_all_stack_old: (state: PerformanceState) => {
    return state.memory_all_stack_old;
  },
  memory_sub_stack: (state: PerformanceState) => {
    return state.memory_sub_stack;
  },
  memory_stack_old: (state: PerformanceState) => {
    return state.memory_stack_old;
  },
  memory_module_list: (state: PerformanceState) => {
    return state.memory_module_list;
  },
  memory_function_list_all: (state: PerformanceState) => {
    return state.memory_function_list_all;
  },
  memory_function_appoint: (state: PerformanceState) => {
    return state.memory_function_appoint;
  },
  memory_function_appoint_old: (state: PerformanceState) => {
    return state.memory_function_appoint_old;
  },
  memory_module_list_appoint: (state: PerformanceState) => {
    return state.memory_module_list_appoint;
  },
  memory_module_list_appoint_old: (state: PerformanceState) => {
    return state.memory_module_list_appoint_old;
  },
  memory_module_list_second: (state: PerformanceState) => {
    return state.memory_module_list_second;
  },
  memory_module_trend: (state: PerformanceState) => {
    return state.memory_module_trend;
  },
  memory_module_sub_trend: (state: PerformanceState) => {
    return state.memory_module_sub_trend;
  },
  deep_deepMemreport_data: (state: PerformanceState) => {
    return state.deep_deepMemreport_data;
  },
  deep_memory_download: (state: PerformanceState) => {
    return state.deep_memory_download;
  },
  deep_memory_data: (state: PerformanceState) => {
    return state.deep_memory_data;
  },
  deep_memory_data_cread: (state: PerformanceState) => {
    return state.deep_memory_data_cread;
  },
  deep_memory_data_cread_old: (state: PerformanceState) => {
    return state.deep_memory_data_cread_old;
  },
  deep_memory_report: (state: PerformanceState) => {
    return state.deep_memory_report;
  },
  deep_unity_memory_report: (state: PerformanceState) => {
    return state.deep_unity_memory_report;
  },
  deep_unity_memory_list: (state: PerformanceState) => {
    return state.deep_unity_memory_list;
  },
  deep_memory_sub_scene_options: (state: PerformanceState) => {
    return state.deep_memory_sub_scene_options;
  },
  deep_memory_scene_options: (state: PerformanceState) => {
    return state.deep_memory_scene_options;
  },
  simple_type_options: (state: PerformanceState) => {
    return state.simple_type_options;
  },
  simple_device_options: (state: PerformanceState) => {
    return state.simple_device_options;
  },
  simple_version_options: (state: PerformanceState) => {
    return state.simple_version_options;
  },
  simple_version_options_old: (state: PerformanceState) => {
    return state.simple_version_options_old;
  },
  simple_label_options: (state: PerformanceState) => {
    return state.simple_label_options;
  },
  cpu_deivce_options: (state: PerformanceState) => {
    return state.cpu_deivce_options;
  },
  cpu_trend: (state: PerformanceState) => {
    return state.cpu_trend;
  },
  cpu_scene_options: (state: PerformanceState) => {
    return state.cpu_scene_options;
  },
  simple_url: (state: PerformanceState) => {
    return state.simple_url;
  },
  simple_process_options: (state: PerformanceState) => {
    return state.simple_process_options;
  },
  simple_thread_options: (state: PerformanceState) => {
    return state.simple_thread_options;
  },
  simple_so_options: (state: PerformanceState) => {
    return state.simple_so_options;
  },
  simple_trend_params: (state: PerformanceState) => {
    return state.simple_trend_params;
  },
  simple_total_params: (state: PerformanceState) => {
    return state.simple_total_params;
  },
  simple_scene_options: (state: PerformanceState) => {
    return state.simple_scene_options;
  },
  simple_table: (state: PerformanceState) => {
    return state.simple_table;
  },
  simple_log: (state: PerformanceState) => {
    return state.simple_log;
  },
  simple_report_options: (state: PerformanceState) => {
    return state.simple_report_options;
  },
  simple_subtype_options: (state: PerformanceState) => {
    return state.simple_subtype_options;
  },
  simple_data: (state: PerformanceState) => {
    return state.simple_data;
  },
  simple_by_data: (state: PerformanceState) => {
    return state.simple_by_data;
  },
  abd_date_options: (state: PerformanceState) => {
    return state.abd_date_options;
  },
  smoke_by_report: (state: PerformanceState) => {
    return state.smoke_by_report;
  },
  light_smoke_scene: (state: PerformanceState) => {
    return state.light_smoke_scene;
  },
  light_smoke_version: (state: PerformanceState) => {
    return state.light_smoke_version;
  },
  light_common_key: (state: PerformanceState) => {
    return state.light_common_key;
  },
  light_common_url: (state: PerformanceState) => {
    return state.light_common_url;
  },
  light_smoke_devices: (state: PerformanceState) => {
    return state.light_smoke_devices;
  },
  light_smoke_tod_devices: (state: PerformanceState) => {
    return state.light_smoke_tod_devices;
  },
  light_smoke_list: (state: PerformanceState) => {
    return state.light_smoke_list;
  },
  abd_device_options: (state: PerformanceState) => {
    return state.abd_device_options;
  },
  abd_scene_options: (state: PerformanceState) => {
    return state.abd_scene_options;
  },
  abd_subtype_options: (state: PerformanceState) => {
    return state.abd_subtype_options;
  },
  abd_list: (state: PerformanceState) => {
    return state.abd_list;
  },
  light_date_options: (state: PerformanceState) => {
    return state.light_date_options;
  },
  android_app_date_options: (state: PerformanceState) => {
    return state.android_app_date_options;
  },
  android_offline_date: (state: PerformanceState) => {
    return state.android_offline_date;
  },
  perfetto_options: (state: PerformanceState) => {
    return state.perfetto_options;
  },
  perfetto_type_options: (state: PerformanceState) => {
    return state.perfetto_type_options;
  },
  xcode_type_options: (state: PerformanceState) => {
    return state.xcode_type_options;
  },
  xcode_date_options: (state: PerformanceState) => {
    return state.xcode_date_options;
  },
  xcode_device_options: (state: PerformanceState) => {
    return state.xcode_device_options;
  },
  xcode_level_options: (state: PerformanceState) => {
    return state.xcode_level_options;
  },
  xcode_scene_options: (state: PerformanceState) => {
    return state.xcode_scene_options;
  },
  xcode_dimens_options: (state: PerformanceState) => {
    return state.xcode_dimens_options;
  },
  perfetto_settings: (state: PerformanceState) => {
    return state.perfetto_settings;
  },
  performance_svg_log: (state: PerformanceState) => {
    return state.performance_svg_log;
  },
  performance_ds_log: (state: PerformanceState) => {
    return state.performance_ds_log;
  },
  performance_svg_log_data: (state: PerformanceState) => {
    return state.performance_svg_log_data;
  },
  performance_ds_log_data: (state: PerformanceState) => {
    return state.performance_ds_log_data;
  },
  perfetto_old_date: (state: PerformanceState) => {
    return state.perfetto_old_date;
  },
  perfetto_device_options: (state: PerformanceState) => {
    return state.perfetto_device_options;
  },
  perfetto_device_options_trend: (state: PerformanceState) => {
    return state.perfetto_device_options_trend;
  },
  perfetto_device_options_important: (state: PerformanceState) => {
    return state.perfetto_device_options_important;
  },
  perfetto_native_trend: (state: PerformanceState) => {
    return state.perfetto_native_trend;
  },
  xcode_native_trend: (state: PerformanceState) => {
    return state.xcode_native_trend;
  },
  perfetto_native_func_trend: (state: PerformanceState) => {
    return state.perfetto_native_func_trend;
  },
  xcode_native_func_trend: (state: PerformanceState) => {
    return state.xcode_native_func_trend;
  },
  perfetto_so_func_trend: (state: PerformanceState) => {
    return state.perfetto_so_func_trend;
  },
  xcode_so_func_trend: (state: PerformanceState) => {
    return state.xcode_so_func_trend;
  },
  perfetto_native_module: (state: PerformanceState) => {
    return state.perfetto_native_module;
  },
  perfetto_so_list: (state: PerformanceState) => {
    return state.perfetto_so_list;
  },
  perfetto_module_trend: (state: PerformanceState) => {
    return state.perfetto_module_trend;
  },
  perfetto_module_list: (state: PerformanceState) => {
    return state.perfetto_module_list;
  },
  perfetto_native_all: (state: PerformanceState) => {
    return state.perfetto_native_all;
  },
  xcode_native_all: (state: PerformanceState) => {
    return state.xcode_native_all;
  },
  xcode_native_module: (state: PerformanceState) => {
    return state.xcode_native_module;
  },
  perfetto_so_all: (state: PerformanceState) => {
    return state.perfetto_so_all;
  },
  xcode_so_all: (state: PerformanceState) => {
    return state.xcode_so_all;
  },
  object_func_all: (state: PerformanceState) => {
    return state.object_func_all;
  },
  perfetto_level_options: (state: PerformanceState) => {
    return state.perfetto_level_options;
  },
  perfetto_Stack: (state: PerformanceState) => {
    return state.perfetto_Stack;
  },
  xcode_Stack: (state: PerformanceState) => {
    return state.xcode_Stack;
  },
  perfetto_Stack_search: (state: PerformanceState) => {
    return state.perfetto_Stack_search;
  },
  perfetto_Stack_search_v2: (state: PerformanceState) => {
    return state.perfetto_Stack_search_v2;
  },
  perfetto_Stack_search_functions: (state: PerformanceState) => {
    return state.perfetto_Stack_search_functions;
  },
  perfetto_Stack_search_so: (state: PerformanceState) => {
    return state.perfetto_Stack_search_so;
  },
  perfetto_level_options_important: (state: PerformanceState) => {
    return state.perfetto_level_options_important;
  },
  perfetto_scene_options: (state: PerformanceState) => {
    return state.perfetto_scene_options;
  },
  perfetto_report: (state: PerformanceState) => {
    return state.perfetto_report;
  },
  xcode_report: (state: PerformanceState) => {
    return state.xcode_report;
  },
  android_offline_date_old: (state: PerformanceState) => {
    return state.android_offline_date_old;
  },
  android_offline_device: (state: PerformanceState) => {
    return state.android_offline_device;
  },
  light_date_contrast_options: (state: PerformanceState) => {
    return state.light_date_contrast_options;
  },
  android_offline_scenes: (state: PerformanceState) => {
    return state.android_offline_scenes;
  },
  android_offline_subtypes: (state: PerformanceState) => {
    return state.android_offline_subtypes;
  },
  android_offline_list: (state: PerformanceState) => {
    return state.android_offline_list;
  },
  android_offline_old_list: (state: PerformanceState) => {
    return state.android_offline_old_list;
  },
  android_offline_thread_old_list: (state: PerformanceState) => {
    return state.android_offline_thread_old_list;
  },
  android_thread_compare: (state: PerformanceState) => {
    return state.android_thread_compare;
  },
  android_course_compare: (state: PerformanceState) => {
    return state.android_course_compare;
  },
  android_thread_options: (state: PerformanceState) => {
    return state.android_thread_options;
  },
  android_course_options: (state: PerformanceState) => {
    return state.android_course_options;
  },
  android_offline_zip: (state: PerformanceState) => {
    return state.android_offline_zip;
  },
  android_offline_url: (state: PerformanceState) => {
    return state.android_offline_url;
  },
  android_course_trend: (state: PerformanceState) => {
    return state.android_course_trend;
  },
  android_thread_trend: (state: PerformanceState) => {
    return state.android_thread_trend;
  },
  android_course_process_list: (state: PerformanceState) => {
    return state.android_course_process_list;
  },
  android_thread_process_list: (state: PerformanceState) => {
    return state.android_thread_process_list;
  },
  android_app_date_contrast_options: (state: PerformanceState) => {
    return state.android_app_date_contrast_options;
  },
  light_resour_cost_options: (state: PerformanceState) => {
    return state.light_resour_cost_options;
  },
  deep_cpu_func_report: (state: PerformanceState) => {
    return state.deep_cpu_func_report;
  },
  android_app_file_compare: (state: PerformanceState) => {
    return state.android_app_file_compare;
  },
  light_jank_cost_options: (state: PerformanceState) => {
    return state.light_jank_cost_options;
  },
  light_method_cost_options: (state: PerformanceState) => {
    return state.light_method_cost_options;
  },
  light_device_options: (state: PerformanceState) => {
    return state.light_device_options;
  },
  android_app_device_options: (state: PerformanceState) => {
    return state.android_app_device_options;
  },
  android_app_zip: (state: PerformanceState) => {
    return state.android_app_zip;
  },
  light_scene_options: (state: PerformanceState) => {
    return state.light_scene_options;
  },
  android_app_scene_options: (state: PerformanceState) => {
    return state.android_app_scene_options;
  },
  light_subtype_options: (state: PerformanceState) => {
    return state.light_subtype_options;
  },
  android_app_subtype_options: (state: PerformanceState) => {
    return state.android_app_subtype_options;
  },
  light_log_options: (state: PerformanceState) => {
    return state.light_log_options;
  },
  android_app_log_options: (state: PerformanceState) => {
    return state.android_app_log_options;
  },
  light_resource: (state: PerformanceState) => {
    return state.light_resource;
  },
  android_app_file_data: (state: PerformanceState) => {
    return state.android_app_file_data;
  },
  light_jank: (state: PerformanceState) => {
    return state.light_jank;
  },
  light_method: (state: PerformanceState) => {
    return state.light_method;
  },
  light_functions: (state: PerformanceState) => {
    return state.light_functions;
  },
  light_url: (state: PerformanceState) => {
    return state.light_url;
  },
  android_app_filename: (state: PerformanceState) => {
    return state.android_app_filename;
  },
  android_app_url: (state: PerformanceState) => {
    return state.android_app_url;
  },
  light_trend: (state: PerformanceState) => {
    return state.light_trend;
  },
  android_app_file_trend: (state: PerformanceState) => {
    return state.android_app_file_trend;
  },
  abd_type: (state: PerformanceState) => {
    return state.abd_type;
  },
  abd_Process: (state: PerformanceState) => {
    return state.abd_Process;
  },
  memory_resouce_speed_options: (state: PerformanceState) => {
    return state.memory_resouce_speed_options;
  },
  memory_resouce_vehice: (state: PerformanceState) => {
    return state.memory_resouce_vehice;
  },
  abd_sum: (state: PerformanceState) => {
    return state.abd_sum;
  },
  abd_date_single: (state: PerformanceState) => {
    return state.abd_date_single;
  },
  abd_compare: (state: PerformanceState) => {
    return state.abd_compare;
  },
  abd_process_compare: (state: PerformanceState) => {
    return state.abd_process_compare;
  },
  abd_log: (state: PerformanceState) => {
    return state.abd_log;
  },
  abd_url: (state: PerformanceState) => {
    return state.abd_url;
  },
  live_report_list: (state: PerformanceState) => {
    return state.live_report_list;
  },
  perf_reprot: (state: PerformanceState) => {
    return state.perf_report;
  },
  weapon_report: (state: PerformanceState) => {
    return state.weapon_report;
  },
  nzm_report: (state: PerformanceState) => {
    return state.nzm_report;
  },
  perf_reprot_gpu: (state: PerformanceState) => {
    return state.perf_report_gpu;
  },
  live_reprot: (state: PerformanceState) => {
    return state.live_report;
  },
  perf_reprot_id_test: (state: PerformanceState) => {
    return state.perf_report_id_test;
  },
  stress_perf_reprot: (state: PerformanceState) => {
    return state.stress_perf_report;
  },
  label_reprot: (state: PerformanceState) => {
    return state.label_report;
  },
  aov_copy_perf_to_report: (state: PerformanceState) => {
    return state.aov_copy_perf_to_report;
  },
  perf_dashboard: (state: PerformanceState) => {
    return state.perf_dashboard;
  },
  performance_analysis: (state: PerformanceState) => {
    return state.performance_analysis;
  },
  performance_aov_trend: (state: PerformanceState) => {
    return state.performance_aov_trend;
  },
  aov_performances: (state: PerformanceState) => {
    return state.aov_performances;
  },
  task_record_query: (state: PerformanceState) => {
    return state.task_record_query;
  },
  task_record_devices: (state: PerformanceState) => {
    return state.task_record_devices;
  },
  last_record: (state: PerformanceState) => {
    return state.last_record;
  },
  recent_taskrecord: (state: PerformanceState) => {
    return state.recent_taskrecord;
  },
  codm_report: (state: PerformanceState) => {
    return state.codm_report;
  },
  codm_reports: (state: PerformanceState) => {
    return state.codm_reports;
  },
  top_reports: (state: PerformanceState) => {
    return state.top_reports;
  },
  top_report_detail: (state: PerformanceState) => {
    return state.top_report_detail;
  },
  top_report: (state: PerformanceState) => {
    return state.top_report;
  },
  top_report_table: (state: PerformanceState) => {
    return state.top_report_table;
  },
  top_report_table_list: (state: PerformanceState) => {
    return state.top_report_table_list;
  },
  xhook_report_list: (state: PerformanceState) => {
    return state.xhook_report_list;
  },
  xhook_report: (state: PerformanceState) => {
    return state.xhook_report;
  },
  wedo_report_detail: (state: PerformanceState) => {
    return state.Wado_report;
  },
  skin_report: (state: PerformanceState) => {
    return state.Skin_report;
  },
  Skin_report_option: (state: PerformanceState) => {
    return state.Skin_report_option;
  },
  Skin_report_list: (state: PerformanceState) => {
    return state.Skin_report_list;
  },
  Skin_report_option_old: (state: PerformanceState) => {
    return state.Skin_report_option_old;
  },
  Skin_report_whole: (state: PerformanceState) => {
    return state.Skin_report_whole;
  },
  Skin_report_data: (state: PerformanceState) => {
    return state.Skin_report_data;
  },
  Skin_report_compare_data: (state: PerformanceState) => {
    return state.Skin_report_compare_data;
  },
  skin_report_inside: (state: PerformanceState) => {
    return state.Skin_report_inside;
  },
  smg_report: (state: PerformanceState) => {
    return state.smg_report;
  },
  Skin_report_table: (state: PerformanceState) => {
    return state.Skin_report_table;
  },
  arrange: (state: PerformanceState) => {
    return state.arrange;
  },
  log_download: (state: PerformanceState) => {
    return state.Log_download;
  },
  smoke_report: (state: PerformanceState) => {
    return state.Smoke_Report;
  },
  protocol_report: (state: PerformanceState) => {
    return state.protocol_report;
  },
  Login_Smoke_Report: (state: PerformanceState) => {
    return state.Login_Smoke_Report;
  },
  smoke_report_list: (state: PerformanceState) => {
    return state.smoke_reports;
  },
  protocol_list: (state: PerformanceState) => {
    return state.protocol_list;
  },
  login_smoke_reports: (state: PerformanceState) => {
    return state.login_smoke_reports;
  },
  Performance_version: (state: PerformanceState) => {
    return state.Performance_version;
  },
  deep_performance_details: (state: PerformanceState) => {
    return state.deep_performance_details;
  },
  case_monitor_list: (state: PerformanceState) => {
    return state.case_monitor_list;
  },
  case_monito: (state: PerformanceState) => {
    return state.case_monito;
  },
  deep_performance_stack: (state: PerformanceState) => {
    return state.deep_performance_stack;
  },
  instantiation_list: (state: PerformanceState) => {
    return state.instantiations;
  },
  instantiation_data: (state: PerformanceState) => {
    return state.instantiation;
  },
  Change_fps_lte: (state: PerformanceState) => {
    return state.change_fPS_lte;
  },
  Change_fps_gte: (state: PerformanceState) => {
    return state.change_fPS_gte;
  },
  player_id: (state: PerformanceState) => {
    return state.player_id;
  },
  dc: (state: PerformanceState) => {
    return state.dc;
  },
  dc_report: (state: PerformanceState) => {
    return state.dc_report;
  },
  task_list: (state: PerformanceState) => {
    return state.task_list;
  },
};

const { read } = getStoreAccessors<PerformanceState, State>("");

export const readPerformances = read(getters.performances);
export const readAllPerformances = read(getters.all_performances);
export const readUploadTopPerformanceLoad = read(getters.upload_top_performance_load);
export const readTopTemplates = read(getters.top_templates);
export const readTopBaselines= read(getters.top_baselines);
export const readTopTemplatesData = read(getters.top_templates_data);
export const readTopBaselinesData = read(getters.top_baselines_data);
export const readPerformanceTableFields = read(getters.performanceTableFields);
export const readPerformanceSelectOptions = read(
  getters.performance_select_options
);
export const readPerformanceCustomVersion = read(
  getters.performance_custom_version
);
export const readDeepPerformanceSelectOptions = read(
  getters.deep_performance_select_options
);
export const readDeepPerformanceSelectOptionsOld = read(
  getters.deep_performance_select_options_old
);
export const readDeepPerformanceSelectOptionsLast= read(
  getters.deep_performance_select_options_last
);
export const readDeepScene = read(getters.deep_scene);
export const readDeepSceneOptions = read(getters.deep_scene_options);
export const readDeepSceneRport = read(getters.deep_scene_report);
export const readDeepSceneVedio = read(getters.deep_scene_vedio);
export const readDeepSceneOld = read(getters.deep_scene_old);
export const readDeepSceneOldVedio = read(getters.deep_scene_old_vedio);
export const readDeepFind = read(getters.deep_find);
export const readTestInfo = read(getters.test_info);
export const readPerformancePageList = read(getters.performance_page_list);
export const readPerformancePageListSummary = read(getters.setPerformancePageListSummary);
export const readDeepPerformancePageList = read(
  getters.deep_performance_page_list
);
export const readLabelInfo = read(getters.label_info);
export const readLabelInfoLabel = read(getters.label_info_laebl);
export const readAvgData = read(getters.avg_data);
export const readPerfInfo = read(getters.perf_info);
export const readPerfSecondData = read(getters.perf_second_data);
export const readReportList = read(getters.reprot_list);
export const readPerfReport = read(getters.perf_reprot);
export const readWeaponReport = read(getters.weapon_report);
export const readNzmReport = read(getters.nzm_report);
export const readPerfReportGpu = read(getters.perf_reprot_gpu);
export const readLivefReport = read(getters.live_reprot);
export const readPerfReportIdTest = read(getters.perf_reprot_id_test);
export const readStressPerfReport = read(getters.stress_perf_reprot);
export const readLabelReport = read(getters.label_reprot);
export const readAovCopyPerfToReport = read(getters.aov_copy_perf_to_report);
export const readNewReport = read(getters.new_reprot);
export const readNewSmgReport = read(getters.new_smg_report);
export const readPerfDashboard = read(getters.perf_dashboard);
export const readPerformanceAnalysis = read(getters.performance_analysis);
export const readPerformanceAovTrend = read(getters.performance_aov_trend);
export const readAovPerformances = read(getters.aov_performances);
export const readTaskRecordQuery = read(getters.task_record_query);
export const readTaskRecordDevices = read(getters.task_record_devices);
export const readLastRecord = read(getters.last_record);
export const readRecentTaskrecord = read(getters.recent_taskrecord);
export const readNewReportList = read(getters.new_report_list);
export const readLiveReportList = read(getters.live_report_list);
export const readDateVersions = read(getters.date_versions);
export const readCODMReport = read(getters.codm_report);
export const readCODMReportList = read(getters.codm_reports);
export const readTOPReportList = read(getters.top_reports);
export const readTOPReportDetail = read(getters.top_report_detail);
export const readTOPReport = read(getters.top_report);
export const readTOPReportTable = read(getters.top_report_table);
export const readTOPReportTableList = read(getters.top_report_table_list);
export const readXhookReportList = read(getters.xhook_report_list);
export const readXhookReport = read(getters.xhook_report);
export const readWedoReport = read(getters.wedo_report_detail);
export const readSkinReport = read(getters.skin_report);
export const readSkinReportOption = read(getters.Skin_report_option);
export const readSkinReportList= read(getters.Skin_report_list);
export const readSkinReportOptionOld = read(getters.Skin_report_option_old);
export const readSkinReportWhole= read(getters.Skin_report_whole);
export const readSkinReportData= read(getters. Skin_report_data);
export const readSkinReportTableData= read(getters. Skin_report_table);
export const readArrange= read(getters. arrange);
export const readSkinReportcomparedata= read(getters. Skin_report_compare_data);
export const readSkinReportInside = read(getters.skin_report_inside);
export const readSmgReport = read(getters.smg_report);
export const readLogDownload = read(getters.log_download);
export const readSmokeReport = read(getters.smoke_report);
export const readProtocolReport = read(getters.protocol_report);
export const readLoginSmokeReport = read(getters.Login_Smoke_Report);
export const readSmokeReportList = read(getters.smoke_report_list);
export const readProtocolList = read(getters.protocol_list);
export const readLoginSmokeReportList = read(getters.login_smoke_reports);
export const readPerformanceVersion = read(getters.Performance_version);
export const readDeepPerformanceDetails = read(
  getters.deep_performance_details
);
export const readCaseMonitorList= read(
  getters.case_monitor_list
);
export const readCaseMonitor= read(
  getters.case_monito
);
export const readInstantiationList = read(getters.instantiation_list);
export const readInstantiationData = read(getters.instantiation_data);
export const readDeepPerformanceStack = read(getters.deep_performance_stack);
export const readChangeFPSlte = read(getters.Change_fps_lte);
export const readChangeFPSgte = read(getters.Change_fps_gte);
export const readGetPlayerid = read(getters.player_id);
export const readGetDC = read(getters.dc);
export const readGetDcReport = read(getters.dc_report);
export const readGetTaskList = read(getters.task_list);
export const readGetNzmMemoryStackAll = read(getters.nzm_memory_stack_all);
export const readGetSkinManagement = read(getters.skin_management);
export const readGetSgameSkinOption = read(getters.sgame_skin_option);
export const readGetSgameSkinData = read(getters.sgame_skin_data);
export const readGetSgameSkinList= read(getters.sgame_skin_list);
export const readGetSkinPkg = read(getters.skin_pkg);
export const readGetSkinDate = read(getters.skin_date);
export const readGetSkinLineView = read(getters.skin_line_viewt);
export const readGetTestCaseList = read(getters.test_case_list);
export const readGetTestCase = read(getters.test_case);
export const readGetCaseControl = read(getters.case_control);
export const readGetSimpleDateOptions = read(getters.simple_date_options);
export const readGetSimpleTypeOptions = read(getters.simple_type_options);
export const readGetSimpleDeviceOptions = read(getters.simple_device_options);
export const readGetSimpleVersionOptions = read(getters.simple_version_options);
export const readGetSimpleVersionOptionsOld = read(getters.simple_version_options_old);
export const readGetSimpleLabelOptions = read(getters.simple_label_options);
export const readGeCpuDeviceOptions = read(getters.cpu_deivce_options);
export const readGeCpuTrend = read(getters.cpu_trend);
export const readGeCpuSceneOptions = read(getters.cpu_scene_options);
export const readGetSimpleUrl = read(getters.simple_url);
export const readGetSimpleProcessOptions = read(getters.simple_process_options);
export const readGetSimpleThreadOptions = read(getters.simple_thread_options);
export const readGetSimpleSoOptions = read(getters.simple_so_options);
export const readGetSimpleTrendParams = read(getters.simple_trend_params);
export const readGetSimpleTotalParams= read(getters.simple_total_params);
export const readGetSimpleSceneOptions = read(getters.simple_scene_options);
export const readGetSimpleTable = read(getters.simple_table);
export const readGetSimpleLog = read(getters.simple_log);
export const readGetSimpleReportOptions = read(getters.simple_report_options);
export const readGetSimplSubtypeOptions = read(getters.simple_subtype_options);
export const readGetSimpleData = read(getters.simple_data);
export const readGetSimpleByData = read(getters.simple_by_data);
export const readGetAbdDateOptions = read(getters.abd_date_options);
export const readGetSmokeByReport = read(getters.smoke_by_report);
export const readGetLightSmokeScenes= read(getters.light_smoke_scene);
export const readGetLightSmokeVersions= read(getters.light_smoke_version);
export const readGetLightCommonKey= read(getters.light_common_key);
export const readGetLightCommonUrl= read(getters.light_common_url);
export const readGetLightSmokeDevices= read(getters.light_smoke_devices);
export const readGetLightSmokeTodDevices= read(getters.light_smoke_tod_devices);
export const readGetLightSmokeList= read(getters.light_smoke_list);
export const readGetAbdDeviceOptions = read(getters.abd_device_options);
export const readGetAbdSceneOptions = read(getters.abd_scene_options);
export const readGetAbdSubtypeOptions = read(getters.abd_subtype_options);
export const readGetAbdList = read(getters.abd_list);
export const readGetLightPerfDate = read(getters.light_date_options);
export const readGetAndroidAppDate = read(getters.android_app_date_options);
export const readGetAndroidOfflineDate= read(getters.android_offline_date);
export const readGetPerfettoOptions= read(getters.perfetto_options);
export const readGetPerfettoTypeOptions= read(getters.perfetto_type_options);
export const readGetXcodeTypeOptions= read(getters.xcode_type_options);
export const readGetXcodeDateOptions= read(getters.xcode_date_options);
export const readGetXcodeDeviceOptions= read(getters.xcode_device_options);
export const readGetXcodeLevelOptions= read(getters.xcode_level_options);
export const readGetXcodeSceneOptions= read(getters.xcode_scene_options);
export const readGetXcodeDimensOptions= read(getters.xcode_dimens_options);
export const readGetPerfettoSettings= read(getters.perfetto_settings);
export const readGetPerfeformanceSvgLog= read(getters.performance_svg_log);
export const readGetPerfeformanceDsLog= read(getters.performance_ds_log);
export const readGetPerfeformanceSvgLogData= read(getters.performance_svg_log_data);
export const readGetPerfeformanceDsLogData= read(getters.performance_ds_log_data);
export const readGetPerfeformanceOldDate= read(getters.perfetto_old_date);
export const readGetPerfettoDeviceOptions= read(getters.perfetto_device_options);
export const readGetPerfettoDeviceOptionsTrend= read(getters.perfetto_device_options_trend);
export const readGetPerfettoDeviceOptionsImportant= read(getters.perfetto_device_options_important);
export const readGetPerfettoNativeTrend= read(getters.perfetto_native_trend);
export const readGetXcodeNativeTrend= read(getters.xcode_native_trend);
export const readGetPerfettoNativeFuncTrend= read(getters.perfetto_native_func_trend);
export const readGetXcodeNativeFuncTrend= read(getters.xcode_native_func_trend);
export const readGetPerfettoSoFuncTrend= read(getters.perfetto_so_func_trend);
export const readGetXcodeSoFuncTrend= read(getters.xcode_so_func_trend);
export const readGetPerfettoNativeModule= read(getters.perfetto_native_module);
export const readGetPerfettoSoList= read(getters.perfetto_so_list);
export const readGetPerfettoModuleTrend= read(getters.perfetto_module_trend);
export const readGetPerfettoModuleList= read(getters.perfetto_module_list);
export const readGetPerfettoNativeAll= read(getters.perfetto_native_all);
export const readGetXcodeNativeAll= read(getters.xcode_native_all);
export const readGetXcodeNativeModule= read(getters.xcode_native_module);
export const readGetPerfettoSoAll= read(getters.perfetto_so_all);
export const readGetXcodeSoAll= read(getters.xcode_so_all);
export const readGetPerfettoFuncAll= read(getters.object_func_all);
export const readGetPerfettoLevelOptions= read(getters.perfetto_level_options);
export const readGetPerfettoStack= read(getters. perfetto_Stack);
export const readGetXcodeStack= read(getters. xcode_Stack);
export const readGetPerfettoStackSearch= read(getters. perfetto_Stack_search);
export const readGetPerfettoStackSearchV2= read(getters. perfetto_Stack_search_v2);
export const readGetPerfettoStackSearchFunctions= read(getters. perfetto_Stack_search_functions);
export const readGetPerfettoStackSearchSo= read(getters. perfetto_Stack_search_so);
export const readGetPerfettoSceneOptions= read(getters.perfetto_scene_options);
export const readGetPerfettoLevelOptionsImportant= read(getters.perfetto_level_options_important);
export const readGetPerfettoReport= read(getters.perfetto_report);
export const readGetXcodeReport= read(getters.xcode_report);
export const readGetAndroidOfflineDateOld= read(getters.android_offline_date_old);
export const readGetAndroidOfflineDevice= read(getters.android_offline_device);
export const readGetAndroidOfflineScenes= read(getters.android_offline_scenes);
export const readGetAndroidOfflineSubtypes= read(getters.android_offline_subtypes);
export const readGetAndroidOfflineList= read(getters.android_offline_list);
export const readGetAndroidOfflineOldList= read(getters.android_offline_old_list);
export const readGetAndroidOfflineThreadOldList= read(getters.android_offline_thread_old_list);
export const readGetAndroidOfflineOfflineZip= read(getters.android_offline_zip);
export const readGetAndroidOfflineOfflineUrl= read(getters.android_offline_url);
export const readGetAndroidThreadCompare= read(getters.android_thread_compare);
export const readGetAndroidCourseCompare= read(getters.android_course_compare);
export const readGetAndroidThreadOptions= read(getters.android_thread_options);
export const readGetAndroidCourseOptions= read(getters.android_course_options);
export const readGetAndroidCourseTrend= read(getters.android_course_trend);
export const readGetAndroidThreadTrend= read(getters.android_thread_trend);
export const readGetAndroidCourseProcessList= read(getters.android_course_process_list);
export const readGetAndroidThreadProcessList= read(getters.android_thread_process_list);
export const readGetLightPerfDateContrast = read(getters.light_date_contrast_options);
export const readGetAndroidAppDateContrast = read(getters.android_app_date_contrast_options);
export const readGetLightPerfResourContrast = read(getters.light_resour_cost_options);
export const readGetAndroidAppDateFileCompare = read(getters.android_app_file_compare);
export const readGetLightPerfJankContrast = read(getters.light_jank_cost_options);
export const readGetLightPerfMethodContrast = read(getters.light_method_cost_options);
export const readGetLightPerfDevice= read(getters.light_device_options);
export const readGetAndroidAppDevice= read(getters.android_app_device_options);
export const readGetAndroidAppZip= read(getters.android_app_zip);
export const readGetLightPerfScene = read(getters.light_scene_options);
export const readGetAndroidAppScene= read(getters.android_app_scene_options);
export const readGetLightPerfSubtype = read(getters.light_subtype_options);
export const readGetAndroidAppSubtype = read(getters.android_app_subtype_options);
export const readGetLightPerfLog = read(getters.light_log_options);
export const readGetAndroidAppLog = read(getters.android_app_log_options);
export const readGetLightPerfResource = read(getters.light_resource);
export const readGetAndroidAppFileData = read(getters.android_app_file_data);
export const readGetLightPerfJank= read(getters.light_jank);
export const readGetLightPerfMethod= read(getters.light_method);
export const readGetLightPerfFunctions= read(getters.light_functions);
export const readGetLightPerfUrl= read(getters.light_url);
export const readGetAndroidAppFilename= read(getters.android_app_filename);
export const readGetAndroidAppFileUrl= read(getters.android_app_url);
export const readGetLightPerfTrend= read(getters.light_trend);
export const readGetAndroidAppFileTrend= read(getters.android_app_file_trend);
export const readGetAbdType = read(getters.abd_type);
export const readGetAbdProcess = read(getters.abd_Process);
export const readGetMemoryResouceOptions= read(getters.memory_resouce_speed_options);
export const readGetMemoryResouceVehice= read(getters.memory_resouce_vehice);
export const readGetAbdSum = read(getters.abd_sum);
export const readGetAbdDateSingle = read(getters.abd_date_single);
export const readGetAbdCompare= read(getters.abd_compare);
export const readGetAbdProcessCompare= read(getters.abd_process_compare);
export const readGetAbdLog= read(getters.abd_log);
export const readGetAbdUrl= read(getters.abd_url);
export const readGetDeepMemoryDeviceOption = read(getters.deep_memory_options);
export const readGetDeepMemoryLlmList = read(getters.deep_memory_llm_list);
export const readGetDeepMemoryTrend = read(getters.deep_memory_trend);
export const readGetDeepMemoryDateOption = read(getters.deep_memory_date_options);
export const readGetDeepMemoryRecondList = read(getters.deep_memory_recond_list);
export const readGetDeepCpuFuncReport = read(getters.deep_cpu_func_report);
export const readGetDeepMemoryCircleChart = read(getters.deep_memory_circle_chart);
export const readGetDeepMemoryUobject = read(getters.deep_uobject);
export const readGetDeepMemoryUobjectTrend = read(getters.deep_uobject_trend);
export const readGetObjectDate= read(getters.memory_date);
export const readGetObjectVersion= read(getters.memory_version);
export const readGetObjectDevice= read(getters.memory_device);
export const readGetObjectDeviceSecond= read(getters.memory_device_second);
export const readGetObjectScene= read(getters.memory_scene);
export const readGetObjectType= read(getters.memory_type);
export const readGetObjectDateVersion= read(getters.memory_date_version);
export const readGetObjectDateVersionNew= read(getters.memory_date_version_new);
export const readGetObjectDateVersionDevice= read(getters.memory_date_version_device);
export const readGetObjectMemoryLevel= read(getters.memory_level);
export const readGetObjectMemorySecond= read(getters.memory_scene_second);
export const readGetObjectModuleAll= read(getters.memory_module_all);
export const readGetObjectMemoryReport= read(getters.memory_object_memory_report);
export const readGetObjectMemoryTrend= read(getters.memory_object_memory_trend);
export const readGetObjectFunctionTrend= read(getters.memory_funtion_trend);
export const readGetObjectModuleId= read(getters.memory_module_id);
export const readGetObjectFunctionId= read(getters.memory_funtion_id);
export const readGetObjectFunctionTrendDraw= read(getters.memory_funtion_trend_draw);
export const readGetObjectList= read(getters.memory_list);
export const readGetObjectListData= read(getters.memory_list_data);
export const readGetObjectStack= read(getters.memory_stack);
export const readGetObjectSubStackOld= read(getters.memory_sub_stack_old);
export const readGetObjectSubStack= read(getters.memory_sub_stack);
export const readGetObjectStackOld= read(getters.memory_stack_old);
export const readGetObjectAllStack= read(getters.memory_all_stack);
export const readGetObjectAppoinStack= read(getters.memory_appoint_stack);
export const readGetObjectAppoinOldLeftStack= read(getters.memory_appoint_old_left_stack);
export const readGetObjectAppoinOldRightStack= read(getters.memory_appoint_old_right_stack);
export const readGetObjectAllStackOld= read(getters.memory_all_stack_old);
export const readGetObjectModuleList= read(getters.memory_module_list);
export const readGetObjectFunctionList= read(getters.memory_function_list_all);
export const readGetObjectFunctionAppoint= read(getters.memory_function_appoint);
export const readGetObjectFunctionAppointOld= read(getters.memory_function_appoint_old);
export const readGetObjectModuleListSecond= read(getters.memory_module_list_second);
export const readGetObjectModuleListAppoint= read(getters.memory_module_list_appoint);
export const readGetObjectModuleListAppointOld= read(getters.memory_module_list_appoint_old);
export const readGetObjectModuleTrend= read(getters.memory_module_trend);
export const readGetObjectModuleSubTrend= read(getters.memory_module_sub_trend);
export const readGetDeepMemreportData= read(getters.deep_deepMemreport_data);
export const readGetDeepMemreportDownload= read(getters.deep_memory_download);
export const readGetDeepMemorySubsceneOption= read(getters.deep_memory_sub_scene_options);
export const readGetDeepMemorySceneOption = read(getters.deep_memory_scene_options);
export const readGetDeepMemoryData = read(getters.deep_memory_data);
export const readGetDeepMemoryDataCread = read(getters.deep_memory_data_cread);
export const readGetDeepMemoryDataCreadOld = read(getters.deep_memory_data_cread_old);
export const readGetDeepMemoryReport= read(getters.deep_memory_report);
export const readGetDeepUnityMemoryReport= read(getters.deep_unity_memory_report);
export const readGetDeepUnityMemoryList= read(getters.deep_unity_memory_list);
export const readGetPkgResourceDate= read(getters.pkg_resource_date);
export const readGetPkgResourceDevice= read(getters.pkg_resource_device);
export const readGetPkgResourceScene= read(getters.pkg_resource_scene);
export const readGetPkgResourceList =read(getters.pkg_resource_list);
export const readGetPkgResourceReport =read(getters.pkg_resource_report);
export const readGetPkgResourceListOld =read(getters.pkg_resource_list_old);
export const readGetPkgResourceListThreadOld =read(getters.pkg_resource_list_thread_old);
export const readGetPkgResourceTrend =read(getters.pkg_resource_trend);
export const readGetPkgAssetTrend =read(getters.pkg_asset_trend);
export const readGetPkgStructTrend =read(getters.pkg_struct_trend);
export const readGetPkgAbnormaTrend =read(getters.pkg_abnorma_trend);
export const readGetPkgMapStructTrend =read(getters.pkg_map_struct_trend);
export const readGetPkgResourceSum=read(getters.pkg_resource_sum);
export const readGetPkgResourceRate=read(getters.pkg_type_rate);
export const readGetPkgAssetStack=read(getters.pkg_asset_stack);
export const readGetPkgAssetType=read(getters.pkg_asset_type);
export const readGetPkgStructStack=read(getters.pkg_struct_stack);
export const readGetSpeedmMemoryList=read(getters.speedm_memory_list);
export const readGetSpeedmMemoryConfig=read(getters.speedm_memory_config);
export const readGetMemSummaryList=read(getters.mem_summary_list);
export const readGetMemSummaryTrend=read(getters.mem_summary_trend);
export const readGetMemSummaryTrendIos=read(getters.mem_summary_trend_ios);
export const readGetMemDateVersions=read(getters.mem_date_versions);
export const readGetMemSummaryListV1=read(getters.mem_summary_list_v1);
export const readGetResourceDates=read(getters.resource_dates);
export const readGetResourceCarList=read(getters.resource_car_list);
export const readGetResourceLoadList=read(getters.resource_load_list);
export const readGetResourceSkinList=read(getters.resource_skin_list);
export const readGetResourceOverall=read(getters.resource_overall);
export const readGetResourceAverageData=read(getters.resource_average_data);
export const readGetResourceChart=read(getters.resource_average_chart);
export const readGetResourceHistory=read(getters.resource_history);
export const readGetResourceChartAvg=read(getters.resource_average_chart_avg);
export const readGetResourceTypeList=read(getters.resource_scan_type_list);
export const readGetResourceCarData=read(getters.resource_car_data);
export const readGetResourceRecords=read(getters.resource_records);
export const readGetResourceVersions=read(getters.resource_versions);
export const readGetResourceDevices=read(getters.resource_devices);
export const readGetResourceScenes=read(getters.resource_scenes);
export const readGetResourceId=read(getters.resource_id);
export const readGetSpeedmMemoryScenes=read(getters.speedm_memory_scenes);
export const readGetSpeedmMemoryRecords=read(getters.speedm_memory_records);
export const readGetSpeedmMemoryFilenameList=read(getters.speedm_memory_filename_list);
export const readGetSpeedmMemorySourceList=read(getters.speedm_memory_source_list);
export const readGetSpeedmMemorySourceFileList=read(getters.speedm_memory_source_file_list);
export const readGetSpeedmModSummary=read(getters.speedm_mod_summary);
export const readGetSpeedmModSummaryV1=read(getters.speedm_mod_summary_v1);
export const readGetSpeedmMemoryResSummary=read(getters.speedm_memory_res_summary);
export const readGetSpeedmModList=read(getters.speedm_mod_list);
export const readGetSpeedmModResList=read(getters.speedm_mod_res_list);
export const readGetSpeedmMemoryResTrend=read(getters.speedm_memory_res_trend);
export const readGetSpeedmSummaryList=read(getters.speedm_summary_list);
export const readGetSpeedmModTrend=read(getters.speedm_mod_trend);
export const readGetSpeedmMemoryTrend=read(getters.speedm_memory_trend);
export const readGetSpeedmMemorySummary=read(getters.speedm_memory_summary);
export const readGetPkgMapStructStack=read(getters.pkg_map_struct_stack);
export const readGetPkgMapStructStackList=read(getters.pkg_map_struct_stack_list);
export const readGetPkgMapStructStackOption=read(getters.pkg_map_struct_stack_option);
export const readGetPkgAssetStackFind=read(getters.pkg_asset_stack_find);
export const readGetPkgResourceStack=read(getters.pkg_type_list);
export const readGetPkgResourceStackOld=read(getters.pkg_type_list_old);
export const readGetPkgResourceTable=read(getters.pkg_type_table);
export const readGetdeepCpuLabels=read(getters.deep_cpu_labels);
export const readGetdeepCpuUsageTrend=read(getters.deep_cpu_usage_trend);
export const readGetdeepCpuLabelsOld=read(getters.deep_cpu_labels_old);
export const readGetdeepCpuPerfTrend=read(getters.deep_cpu_perf_trend);
export const readGetdeepCpuCustomTrend=read(getters.deep_cpu_custom_trend);
export const readGetdeepCpuThreads=read(getters.deep_cpu_threads);
export const readGetdeepFpsInsideTrend=read(getters.deep_fps_inside_trend);
export const readGetdeepCpuTrend=read(getters.deep_cpu_trend);
export const readGetdeepFlameUrl=read(getters.deep_flame_url);
export const readGetdeepCpuSoTrend=read(getters.deep_cpu_so_trend);
export const readGetdeepCpuThreadTrend=read(getters.deep_cpu_thread_trend);
export const readGetdeepCpuModuleTrend=read(getters.deep_cpu_module_trend);
export const readGetdeepCpuVersions=read(getters.deep_cpu_versions);
export const readGetdeepCpuConfig=read(getters.deep_cpu_config);
export const readGetdeepCpuFuncTrend=read(getters.deep_cpu_func_trend);
export const readGetdeepCpuConfigSoList=read(getters.deep_cpu_config_so_list);
export const readGetdeepCpuVersionsOld=read(getters.deep_cpu_versions_old);
export const readGetdeepCpuFunction=read(getters.deep_cpu_function);
export const readGetdeepCpuFunctionOverview=read(getters.deep_cpu_function_overview);
export const readGetdeepCpuThreadList=read(getters.deep_cpu_thread_list);
export const readGetdeepCpuCustomData=read(getters.deep_cpu_custom_data);
export const readGetdeepCpuUsageList=read(getters.deep_cpu_usage_list);
export const readGetdeepCpuUsageListQQ=read(getters.deep_cpu_usage_list_qq);
export const readGetdeepCpuUsageListMouduleQQ=read(getters.deep_cpu_usage_list_moudule_qq);
export const readGetdeepCpuReport=read(getters.deep_cpu_report);
export const readGetdeepfuncList=read(getters.deep_func_list);
export const readGetdeepCpuByFrame=read(getters.deep_cpu_by_frame);
export const readGetdeepCpuStack=read(getters.deep_cpu_stack);
export const readGetdeepCpuStackFind=read(getters.deep_cpu_stack_find);
export const readGetTokenLibraryList=read(getters.token_library_list);
export const readGetDeepFrameProblem=read(getters.deep_frame_problem);
export const readGetDeepAvgStack=read(getters.deep_avg_stack);
export const readGetdeepCpuStackCreat=read(getters.deep_cpu_stack_creat);
export const readGetdeepCpuStackCreatOld=read(getters.deep_cpu_stack_creat_old);
export const readGetdeepCpuFunctionCos=read(getters.deep_cpu_function_cos);
export const readGetdeepTrendNode=read(getters.deep_cpu_trend_node);
export const readGetdeepCpuFunctionModel=read(getters.deep_cpu_function_model);
export const readGetdeepCpuDetail=read(getters.deep_cpu_detail);
export const readGetdeepCpuThreadByFrame=read(getters.deep_cpu_thread_by_frame);
export const readGetdeepCpuCatonList=read(getters.deep_caton_list);
export const readGetdeepCpuCheck=read(getters.deep_cpu_put_check);
